export default __webpack_public_path__ + "static/media/wing.48b6bc79.svg";